import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../../../_common/Modal/Modal';
import TableAndPagination from '../../../../../_common/TableAndPagination/TableAndPagination';
import Loader from '../../../../../_common/Loader/Loader';
import Api from '../../../../../../api/api';
import classes from '../../../dashboard.module.scss';

const initialState = {
  firstLoad: true,
  loading: false,
  list: [],
  total: 0,
  totalPages: 1,
  page: 1,
  limit: 15,
};

const TopPhysiciansModal = ({
  isOpen, requestData, tableHeader, onClose,
}) => {
  const navigate = useNavigate();

  const [physicians, setPhysicians] = useState(initialState);

  const {
    page, limit, total, totalPages,
  } = physicians;

  useEffect(() => {
    if (!isOpen) {
      setPhysicians(initialState);

      return;
    }

    (async () => {
      try {
        setPhysicians((prev) => ({ ...prev, loading: true }));

        const { data } = await Api.getDashboardTopPhysicians({
          ...requestData,
          page,
          limit,
          cancelKey: 'getDashboardTopPhysiciansList',
        });

        setPhysicians((prev) => ({
          ...prev,
          list: (data?.data?.response || []).map((d, i) => ({
            ...d,
            id: d.physicianId,
            rank: (page - 1) * limit + i + 1,
            specialty: d.specialty || '-',
          })),
          total: data?.data?._meta?.total || 0,
          totalPages: data?.data?._meta?.pageCount || 1,
          loading: false,
          firstLoad: false,
        }));
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [isOpen, requestData, page, limit]);

  const onChangePageData = (path, value) => {
    setPhysicians((prev) => (path === 'limit'
      ? { ...prev, limit: value, page: 1 }
      : { ...prev, page: value }));
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={classes.kpi_modal}
    >
      <div className={classes.kpi_modal_content}>
        <h2>Top physicians by revenue</h2>

        {!physicians.firstLoad && (
          <div className={classes.kpi_modal_caption}>
            <span>{`${total} physicians`}</span>
          </div>
        )}

        <div className={classes.kpi_modal_table}>
          {physicians.firstLoad
            ? (
              <div className={classes.kpi_modal_loader}>
                <Loader />
              </div>
            )

            : (
              <TableAndPagination
                header={tableHeader}
                data={physicians.list}
                loading={physicians.loading}
                className={classes.clickable_row}
                onClick={(physicianId) => navigate(`/physicians/${physicianId}`)}
                onChange={onChangePageData}
                totalPage={totalPages}
                page={page - 1}
                limit={limit}
              />
            )}
        </div>
      </div>
    </Modal>
  );
};

TopPhysiciansModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  requestData: PropTypes.object.isRequired,
  tableHeader: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TopPhysiciansModal;
